import { hexToRgbA } from "./hexToRgbA";

/**
 * `hexToRgbA` is nullable for a hex it cannot parse. Every caller here passes a palette literal, so
 * that arm is unreachable — and falling back to the hex keeps the type a plain `string`, which is
 * what stops a nullable token leaking out through `DefaultTheme` into every typed style object
 * that reads one.
 */
export const rgba = (hex: string, o?: number) => hexToRgbA(hex, o) ?? hex;

export default rgba;
